import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
Vue.use(VueViewer);


import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
});

Vue.filter("localNum", function (value) {
  if (!value) return "0";
  value = Number(value);
  return value.toLocaleString("ar-EG");
});
Vue.filter("charactersLimit", function (value, size) {
  if (!value) return "";
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + "...";
});
Vue.filter("charactersLimitTwo", function (value, size) {
  if (!value) return "";
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size);
});
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    var usertoken = JSON.stringify(window.localStorage.getItem("panelToken"));
    const authUser = JSON.parse(usertoken);
    if (authUser) {
      next();
    } else {
      next({ name: "UserLogin" });
    }
  }
  next();
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
